// InfoPage.js

import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { IoMailOutline } from 'react-icons/io5';
import './InfoPage.css';

const InfoPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls to the top when the component mounts
  }, []);

  return (
    <div className="info-container">
      <section className="welcome-section">
        <h1>Welcome to Looksaway</h1>
        <p>
          In a world where algorithms decide who gets seen, Looksaway puts the power of discovery back in human hands. We believe everyone deserves a chance to be discovered—and to discover interesting people they might never encounter otherwise.
        </p>
        <p>
          Looksaway is where people—not algorithms—decide who they meet next. Whether you're looking to be discovered or to explore and connect with new people, Looksaway creates opportunities for meaningful connections that algorithms typically filter out.
        </p>
      </section>

      <section className="how-it-works terms-section-style">
        <h2>How Looksaway Works</h2>
        
        <h3>Create Your Personal Bio in Less Than 60 Seconds</h3>
        <p></p>
        <ul style={{ paddingLeft: '20px' }}>
          <li>Share your name (first name, nickname, or whatever you prefer)</li>
          <li>Upload a profile photo that represents you</li>
          <li>Write a brief bio (80 words max) that tells your story</li>
          <li>Add your location (as specific or general as you're comfortable with)</li>
          <li>Answer optional ice-breakers to build a more personal connection with new potential followers and supporters</li>
          <li>Include your social links and contact information</li>
        </ul>
        
        <h3>Explore & Discover New People in Seconds</h3>
        <p></p>
        <ul style={{ paddingLeft: '20px' }}>
          <li>Browse through personal bios in the New Posts feed</li>
          <li>Discover randomly featured people in the Discover Posts boxes</li>
          <li>Find interesting people you'd never encounter through traditional algorithms</li>
          <li>Follow profiles you find interesting to stay connected</li>
        </ul>
        
        <h3>Connect & Follow Beyond the Platform</h3>
        <p></p>
        <ul style={{ paddingLeft: '20px' }}>
          <li>Explore more via provided social links</li>
          <li>Track profile views and outbound clicks on your own profile</li>
          <li>See which connections are generating the most interest</li>
          <li>Build followings that extend beyond Looksaway</li>
        </ul>
      </section>

      <section className="contact-section">
        <ul className="sidebar-menu">
          <li className="sidebar-item">
            <Link to="/lookscontactform" className="sidebar-link">
              <div className="sidebar-link-content">
                <div className="sidebar-icon-wrapper">
                  <IoMailOutline className="sidebar-icon" />
                </div>
                <span className="sidebar-text">Contact</span>
              </div>
            </Link>
          </li>
        </ul>
      </section>

      <section className="terms-of-use">
        <h2>Terms of Use</h2>
        <p>
          Looksaway, a service provided by Hyroglf, LLC, is designed to
          facilitate a unique user-driven content sharing experience. By
          accessing or interacting with our servers, services, website, or
          mobile application ("App"), you agree to these Terms of Use ("TOU").
          Your use of Looksaway signifies your acceptance of these TOU. Please
          note that Looksaway is a private platform owned by Hyroglf, LLC. If
          you represent a business using Looksaway, you confirm your authority
          to bind that business to these TOU.
        </p>
        <p>
          Hyroglf, LLC and Looksaway are not responsible for any transactions,
          agreements, or interactions that may result from connections made on
          the platform. Users are solely responsible for their interactions and
          any resulting outcomes.
        </p>

        <h3>License</h3>
        <p>
          Hyroglf, LLC grants you a limited, revocable, non-exclusive,
          non-assignable license to use Looksaway in compliance with these TOU.
          Unauthorized use is not permitted. You are prohibited from misusing
          any content from Looksaway, except for content you personally create.
        </p>

        <h3>Usage Policy</h3>
        <p>
          You agree to use Looksaway responsibly and lawfully, adhering to the
          prohibited content guidelines outlined below. You must respect all
          moderation efforts and the privacy and rights of other users.
        </p>

        <h3>Profile Authenticity</h3>
        <p>
          Users must represent themselves truthfully on Looksaway. While you may use a nickname or preferred name, deliberately misrepresenting your identity or creating fictional personas is prohibited. Looksaway reserves the right to remove profiles that appear to be inauthentic or misleading.
        </p>

        <h3>Prohibited Content</h3>
        <p>The following content is strictly prohibited on Looksaway:</p>
        <ul style={{ paddingLeft: '20px' }}>
          <li>Adult Content: No promotion of adult content or services.</li>
          <li>
            Discrimination: No content that discriminates based on personal
            characteristics.
          </li>
          <li>
            Misleading, Violent, or Hateful Content: No misleading, violent, or
            hateful content.
          </li>
          <li>
            Illegal Activities: No promotion of illegal goods, services, or
            activities.
          </li>
          <li>
            Intellectual Property Infringement: No infringement of intellectual
            property rights.
          </li>
          <li>Spam: No spamming or posting of irrelevant content.</li>
          <li>
            Impersonation: No impersonation of other individuals or entities.
          </li>
        </ul>
      </section>

      <section className="disclaimer-section">
        <h2>Disclaimer & Liability</h2>
        <p>
          Looksaway, provided "AS IS" by Hyroglf, LLC, comes without warranties
          of any kind. Hyroglf, LLC is not liable for any damages or losses
          resulting from your use of Looksaway or from interactions arising
          from its use.
        </p>
      </section>

      <section className="claims-section">
        <h2>Claims & Indemnity</h2>
        <p>
          Any disputes related to these TOU will be governed by the laws of the
          jurisdiction where Hyroglf, LLC is located. You agree to indemnify
          Hyroglf, LLC against any claims related to your use of Looksaway.
        </p>
      </section>

      <section className="miscellaneous-section">
        <h2>Miscellaneous</h2>
        <p>
          These TOU constitute the entire agreement between you and Hyroglf, LLC
          regarding Looksaway. Changes to these TOU will be effective upon
          posting, and your continued use of Looksaway signifies acceptance of
          these changes.
        </p>
      </section>
    </div>
  );
};

export default InfoPage;